import { IActorCore } from '@/modules/Personas/components/ActorCombobox/ActorCombobox.types';

interface ActorOptionProps {
    actor: IActorCore;
}

const ActorOption = ({ actor }: ActorOptionProps) => {
    return (
        <div className="text-xs text-gray-6">
            <div className="truncate">
                {actor.integration_idn} / {actor.connector_idn}
            </div>
            <div>External Id: {actor.external_id}</div>
        </div>
    );
};

export default ActorOption;
